"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodedError = exports.assetToHumanId = exports.assetToId = void 0;
const types_1 = require("./types");
const underscore = (str = '') => str.replace(/[.]/g, '_');
function assetToId(asset) {
    // Handle deprecated asset.activity;
    if ('activity' in asset) {
        // eslint-disable-next-line no-param-reassign
        asset = {
            type: types_1.AssetTypes.ACTIVITY,
            id: asset.activity.identifier,
            version: '1_0',
        };
    }
    if (!('type' in asset && Object.values(types_1.AssetTypes).includes(asset.type))) {
        throw new CodedError('E_ASSET_NOT_SUPPORTED', 'Asset not supported');
    }
    if (!(asset.id && typeof asset.id === 'string' && asset.id.length > 0)) {
        throw new Error('Missing asset id');
    }
    const { type, id, version = 1 } = asset;
    return `${type}.${id}~${underscore(String(version))}`;
}
exports.assetToId = assetToId;
function assetToHumanId(asset) {
    // Handle deprecated asset.activity;
    if ('activity' in asset) {
        return asset.activity.short_name;
    }
    if (!('type' in asset && Object.values(types_1.AssetTypes).includes(asset.type))) {
        throw new CodedError('E_ASSET_NOT_SUPPORTED', 'Asset not supported');
    }
    return asset.human_id || asset.type;
}
exports.assetToHumanId = assetToHumanId;
class CodedError extends Error {
    constructor(code, message, metadata = {}) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.CodedError = CodedError;
//# sourceMappingURL=utils.js.map